import { ASSET_TYPE_ENUM } from 'interfaces/assets'

export const getAssetTypeDisplayNameByEnum = (assetType: number): string => {
  if (ASSET_TYPE_ENUM.CANONICAL_RESOURCE_TYPE_DATABASE === assetType) return 'Database'
  if (ASSET_TYPE_ENUM.CANONICAL_RESOURCE_TYPE_DATASET === assetType) return 'Dataset'
  if (ASSET_TYPE_ENUM.CANONICAL_RESOURCE_TYPE_ATTRIBUTE === assetType) return 'Attribute'
  return 'Unknown'
}
